import { toast } from "react-toastify";
import { getAdminId } from "../utils/authId";
import api from "../config/apiConfig";

export const deleteHistoryApi = async (data) => {
  const adminId = getAdminId();
  try {
    const datas = {
      admin_id: adminId,
      ...data,
    };
    const response = await api.post(`api/clear_history_admin/`, datas);
    toast.success("Deleted successful!", {
      position: "top-center",
      autoClose: 2000,
      closeButton: false,
      className: "custom_toast",
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getDeleteStatusApi = async () => {
  const adminId = getAdminId();
  try {
    const response = await api.get(
      `api/get_chat_delete_control/?admin_id=${adminId}`
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteUpdateApi = async (data) => {
  const adminId = getAdminId();
  try {
    const datas = {
      admin: adminId,
      ...data,
    };
    const response = await api.post(`api/chat_delete_control/`, datas);
    toast.success("Deleted successful!", {
      position: "top-center",
      autoClose: 2000,
      closeButton: false,
      className: "custom_toast",
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteMessageApi = async (data) => {
  try {
    const response = await api.delete(`api/delete_chat/?${data}`);

    return response.data;
  } catch (error) {
    throw error;
  }
};
